export default __webpack_public_path__ + "static/Cost_Hero_Graphic-e6a0abc7f9cb79acb72008ec9475162b.webp";